export const SECURITY_PROFILE_TEXT_RESPONSE_MAX_LENGTH = 500;
